import { useState } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Card from "@mui/material/Card";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import NetworkView from "./components/NetworkView";
import RouteView from "./components/RouteView";
import AreaView from "./components/AreaView";
import MetroStatusCard from "../infohub/components/MetroStatusCard";

function TrafficMonitoring() {
  const { t } = useTranslation();
  // Manage actvie tab state
  const [activeTab, setActiveTab] = useState("network");

  // Handle tab change
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <Card
        sx={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
        }}
      >
        {/* Material-UI Tabs */}
        <Tabs value={activeTab} onChange={handleChange} centered>
          <Tab label={t("trafficMonitoring.monitoring.tabs.network")} value="network" />
          <Tab label={t("trafficMonitoring.monitoring.tabs.area")} value="area" />
          <Tab label={t("trafficMonitoring.monitoring.tabs.route")} value="route" />
        </Tabs>

        {/* Render corresponding view based on active tab */}
        <MDBox sx={{ flexGrow: 1, mt: 1, ml: 1 }}>
          {activeTab === "network" && <NetworkView />}
          {activeTab === "area" && <AreaView />}
          {activeTab === "route" && <RouteView />}
        </MDBox>
      </Card>

      {/* container */}
    </DashboardLayout>
  );
}

export default TrafficMonitoring;
